import { mobile } from "./mobile";
import type { MobileEntityType } from "./types";

/**
 * Notifies the mobile app that an entity was added, updated, or deleted.
 * No-ops outside the mobile WebView.
 *
 * @param entityType - The entity type, must be a recognized MobileEntityType
 * @param action - The mutation that occurred
 * @param entityIds - The affected entity IDs, when available
 */
export function notifyMobileEntityChanged(
  entityType: MobileEntityType,
  action: "add" | "update" | "delete",
  entityIds?: (string | number)[],
): void {
  if (!mobile.isWebview) return;
  mobile.sendToNative("entityChanged", { entityType, action, entityIds });
}
